import { Model as BackboneModel } from 'backbone'
import $ from 'init/jquery'
import { Defaults } from 'es-decorators'

/**
 * Базовая модель
 */
@Defaults({
  additionalOptions: ['requestParameters'],
  requestParameters: {},
})
export class Model extends BackboneModel {
  /**
   * URL модели
   * @returns {string}
   */
  url () {
    let parameters = $.param(this.requestParameters) || '',
      expand = this.expand || '',
      paramSymbol = parameters || expand ? '?' : '',
      paramUnionSymbol = parameters && expand ? '&' : '',
      fragment = `/${paramSymbol}${parameters}${paramUnionSymbol}${expand}`
    return BackboneModel.prototype.url.apply(this, arguments) + fragment
  }

  /**
   * Предынициализация.
   * @param {Object} data
   * @param {Object} options
   */
  beforeRun (data, options) {
  }

  /**
   * Инициализация.
   * @param {Object} data
   * @param {Object} options
   */
  run (data, options) {
  }

  /**
   * Постинициализация.
   * @param {Object} data
   * @param {Object} options
   */
  afterRun (data, options) {
  }

  /** @inheritDoc */
  initialize (data, options) {
    this.attachOptions(options)
    this.beforeRun(data, options)
    this.run(data, options)
    this.afterRun(data, options)
  }

  /**
   * Сохраняем переданные опции, если они входят в массив additionalOptions
   * @param {Object} options Опции
   */
  attachOptions (options) {
    if (options) {
      this.additionalOptions.forEach(optionKey => {
        // проверяем наличие не через !options[optionKey] так как оно может быть указано как null или undefined
        if (options.hasOwnProperty(optionKey)) {
          this[optionKey] = options[optionKey]
        }
      })
    }
  }
}
